import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4 text-center">
        <p>&copy; 2024 MonSite. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;